module.exports = __webpack_public_path__ + "img/CY120021.05c3635e.png";